<app-pan-card [isPageContainer]="true" [header]="'Upload Transactions'" [subheader]="'CSV Only'" pageContainerSize="xl">
  <div (files)="filesDropped($event)" class="flex items-center justify-center w-full" panDragDropFiles>
    <label
      class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
      for="dropzone-file"
    >
      <div class="flex flex-col items-center justify-center py-6">
        <mat-icon class="text-gray-500">cloud_upload</mat-icon>
        <p class="mb-2 text-md text-gray-500"><span class="font-semibold">Click to upload</span> or drag and drop</p>
        <p class="text-xs text-gray-500">CSV only</p>
      </div>
      <input (change)="onCsvPicked($event)" class="hidden" id="dropzone-file" type="file" />
    </label>
  </div>

  <div class="px-8">
    @if (hasSelectedRows()) {
      <app-pan-button (click)="deleteSelectedUploads()" color="danger" [disabled]="isDeleting()"> Delete </app-pan-button>
    }
  </div>

  <div class="flex flex-auto p-8">
    <div class="flex flex-col w-full">
      <div class="w-72 pb-4">
        <ng-select
          data-testid="upload-transactions-uploader-filter"
          appendTo="body"
          placeholder="Filter by uploaded by..."
          [items]="distinctUploaders()"
          [clearable]="true"
          [ngModel]="selectedUploader()"
          (ngModelChange)="selectedUploader.set($event)"
          (change)="onUploaderFilterChange()"
        >
        </ng-select>
      </div>

      <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table class="w-full text-xs text-left rtl:text-right text-gray-500 table-auto">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th scope="col" class="px-2 py-2">
              <input type="checkbox" (change)="toggleSelectAll($event)" [checked]="isAllSelected" />
            </th>
            <th scope="col" class="px-2 py-2">Id</th>
            <th scope="col" class="px-2 py-2">
              <span class="sr-only">Expand/Collapse Row</span>
            </th>
            <th scope="col" class="px-2 py-2 w-144">File name</th>
            <th scope="col" class="px-2 py-2">File type</th>
            <th scope="col" class="px-2 py-2">uploaded by</th>
            <th scope="col" class="px-2 py-2">created</th>
            <th scope="col" class="px-2 py-2">updated</th>
            <th scope="col" class="px-2 py-2">status</th>
            <th scope="col" class="px-2 py-2">status details</th>
            <th scope="col" class="px-2 py-2 break-keep text-nowrap">transaction details</th>
            <th scope="col" class="px-2 py-2 break-keep text-nowrap">number of rows</th>
            <th scope="col" class="px-2 py-2 w-96 whitespace-pre-wrap">messages</th>
            <th scope="col" class="px-2 py-2 w-96 whitespace-pre-wrap">errors</th>
            <th scope="col" class="px-2 py-2 w-96 whitespace-pre-wrap">actions</th>
          </tr>
        </thead>
        <tbody data-accordion="table-column">
          @for (upload of filteredUploads(); track upload.id; let index = $index) {
            <tr
              class="bg-white border-b hover:bg-gray-50 cursor-pointer transition"
              [ngClass]="rowBgColor[upload.status]"
              [id]="'table-column-header-' + index"
              [attr.data-accordion-target]="'#table-column-body-' + index"
              aria-expanded="false"
              [attr.aria-controls]="'table-column-body-' + index"
            >
              <td class="px-2 py-2">
                <input
                  type="checkbox"
                  [checked]="isSelected(upload.id)"
                  (change)="onCheckboxChange($event, upload.id, index)"
                  (click)="$event.stopPropagation()"
                />
              </td>
              <td class="px-2 py-2">
                <span
                  class="cursor-pointer hover:bg-slate-300 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded"
                  (click)="copyUploadId($event, upload.id)"
                  >{{ upload.id.split("-")[0] }}</span
                >
              </td>
              <td class="px-2 py-2 w-4">
                <mat-icon>keyboard_arrow_down</mat-icon>
              </td>
              <td class="px-2 py-2">
                <p>
                  <a [href]="upload.url" class="text-sky-400 underline">{{ upload.original_file_name }}</a>
                </p>
              </td>
              <td class="px-2 py-2">
                <span
                  class="text-white text-xs font-medium me-2 px-2.5 py-0.5 rounded"
                  [ngClass]="fileTypeBgColor[upload.status_details_parsed.file_type]"
                  >{{ upload.status_details_parsed.file_type ?? "unknown" }}</span
                >
              </td>
              <td class="px-2 py-2">
                {{ upload.uploaded_by }}
              </td>
              <td class="px-2 py-2">
                <div class="flex items-center">
                  {{ formatDateAgo(upload.created_at) }}
                </div>
              </td>
              <td class="px-2 py-2">
                <p class="break-keep text-nowrap">{{ formatDateAgo(upload.updated_at) }}</p>
              </td>
              <td class="px-2 py-2">
                <span class="text-white text-xs font-medium me-2 px-2.5 py-0.5 rounded" [ngClass]="statusBgColor[upload.status]">{{
                  upload.status
                }}</span>
              </td>
              <td class="px-2 py-2">
                {{ upload.status_details_parsed.processing_status ?? "" }}
              </td>
              <td class="px-2 py-2">
                {{ renderTransactionStatuses(upload.status_details_parsed.transaction_statuses) }}
              </td>
              <td class="px-2 py-2">
                {{ upload.status_details_parsed.num_rows ?? "" }}
              </td>
              <td class="px-2 py-2">
                <app-upload-branch-alias [upload]="upload" (branchAliasChange)="onUploadBranchAliasChange($event, upload)">
                </app-upload-branch-alias>
              </td>
              <td class="px-2 py-2">
                <div [innerHTML]="upload.status_details_parsed?.error ?? ''"></div>
              </td>
              <td class="px-2 py-2">
                @if (canBeRetried(upload)) {
                  <div>
                    <button
                      (click)="retryUpload(upload)"
                      type="button"
                      class="px-3 py-2 text-xs font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
                    >
                      Retry
                    </button>
                  </div>
                }
              </td>
            </tr>
            <tr
              class="hidden flex-1 overflow-x-auto w-full"
              [id]="'table-column-body-' + index"
              [attr.aria-labelledby]="'table-column-header-' + index"
            >
              <td colspan="12">test content of accordion</td>
            </tr>
          } @empty {
            <td colspan="12">All uploads have been processes and queued up for importing.</td>
          }
        </tbody>
      </table>
      </div>
    </div>
  </div>
</app-pan-card>
